module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"experience":"Опыт работы","experience.beginner":"Начало карьеры","experience.1-3 years":"1-3 года","experience.3-6 years":"3-6 лет","experience.6+ years":"Более 6 лет"}}')
  delete Component.options._Ctor
}
